import Footer from "@/User/Components/Footer";
import Header from "@/User/Components/Header";
import React from 'react';
import { TwilioClientProvider } from '../Contexts/TwilioClientContext';
import { MessagePageProvider } from "../Pages/Message/Contexts/MessageContext";
import TopPage from '@/User/Pages/Top/Index';

const UserDefaultLayout = ({ children, showAuthButton = true, showAppHeader = true, showFooter = true, footerClassName = ''}) => {
    const isTopPage = children.type === TopPage;
    return (
        <TwilioClientProvider>
            <MessagePageProvider>
                <main className="bg-pale-grey font-light text-midnight min-h-dvh">
                    <Header showAuthButton={showAuthButton} showAppHeader={showAppHeader} />

                    {children}

                    {showFooter && (isTopPage ? <Footer className={footerClassName} showGroupLink={true} /> : <Footer className={footerClassName} />)}
                </main>
            </MessagePageProvider>
        </TwilioClientProvider>
    );
};

export default UserDefaultLayout;
